<template>
  <div style="position: relative; height: 100%; width: 100%;">
    <LineChart :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Line as LineChart } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler
)

export default {
  name: 'SimpleLineChart',
  components: { LineChart },
  props: {
    chartData: Object,
    chartOptions: Object
  }
}
</script>
